import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useStore } from "../../helpers";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 250,
        },
    })
);

export const LanaguagesFilter = observer(() => {
    const { mediaStore } = useStore();
    const classes = useStyles();
    const [languages, setLanguages] = useState<string[]>([]);
    const [selected, setSelected] = useState(false);

    const languageOptions = mediaStore.articles?.filters?.langs;
    if (!languageOptions) return null;

    return (
        <div className="mx-4 flex flex-col flex-wrap bg-white">
            <InputLabel className="pl-2">Languages</InputLabel>
            <FormControl className={classes.formControl}>
                <Select
                    multiple
                    variant="standard"
                    native={false}
                    onChange={(event) => {
                        const newLangs = event.target.value as string[];
                        mediaStore.printMediaFilters.lang = newLangs;
                        setLanguages(newLangs);
                        setSelected(true);
                    }}
                    value={languages}
                    renderValue={() => <div>{languages.length} selected</div>}
                >
                    {languageOptions.map((lang) => (
                        <MenuItem key={lang} value={lang}>
                            {lang}
                            {selected && languages.includes(lang) ? (
                                <i className="fa-solid fa-check-circle ml-auto p-2 text-green-500" />
                            ) : null}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
});
